"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const connector_screen_1 = __importDefault(require("../components/connector-screen"));
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const use_celo_1 = require("../use-celo");
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    list: `
    tw-list-disc
    tw-pl-8
    tw-pt-2`,
    container: `
    tw-text-sm`,
});
function Placeholder() {
    const { dapp } = (0, use_celo_1.useCeloInternal)();
    const theme = (0, use_theme_1.default)();
    return (react_1.default.createElement(connector_screen_1.default, { title: "Choose your wallet", content: react_1.default.createElement("div", { className: styles.container, style: { color: theme.textSecondary } },
            "Wallets are tools that create accounts, manage keys, and help users transact on the Celo network.",
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            "In order to interact with",
            ' ',
            react_1.default.createElement("span", { style: { color: theme.primary } }, dapp.name),
            ", you will need to connect your wallet.",
            react_1.default.createElement("br", null),
            "Connecting your wallet means a couple things:",
            react_1.default.createElement("ul", { className: styles.list },
                react_1.default.createElement("li", null,
                    "You will ",
                    react_1.default.createElement("strong", null, "not"),
                    " give control of your assets or keys."),
                react_1.default.createElement("li", null, "You will grant read access the assets you own."),
                react_1.default.createElement("li", null, "You will still need to verify and sign the pending operations."))), footer: {
            desc: `Don't have a wallet yet?`,
            url: 'https://docs.celo.org/getting-started/wallets#celo-compatible-wallets',
            CTA: 'Learn',
        } }));
}
exports.default = Placeholder;
//# sourceMappingURL=placeholder.js.map